import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import HomeView from "@/views/home-view.vue";
import i18n from "@/plugins/i18n";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/about-view.vue"),
  },
  {
    path: "/listings",
    name: "listings",
    component: () =>
      import(/* webpackChunkName: "listings" */ "@/views/listings-view.vue"),
  },
  {
    path: "/listing/:id",
    name: "listing",
    component: () =>
      import(/* webpackChunkName: "listing" */ "@/views/listing-view.vue"),
  },
  {
    path: "/listing/:id/:rest(.*)",
    name: "listing",
    component: () =>
      import(/* webpackChunkName: "listing" */ "@/views/listing-view.vue"),
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () =>
      import(/* webpackChunkName: "checkout" */ "@/views/checkout-view.vue"),
  },
  {
    path: "/map",
    name: "map",
    component: () =>
      import(/* webpackChunkName: "map" */ "@/views/site-map.vue"),
  },
  {
    path: "/success",
    name: "success",
    component: () =>
      import(/* webpackChunkName: "success" */ "@/views/success-view.vue"),
  },
  {
    path: "/cancel",
    name: "cancel",
    component: () =>
      import(/* webpackChunkName: "success" */ "@/views/cancel-view.vue"),
  },
  {
    path: "/inquiry-success",
    name: "inquiry-success",
    component: () =>
      import(
        /* webpackChunkName: "inquiry-success" */ "@/views/inquiry-success-view.vue"
      ),
  },
  {
    path: "/search-widget",
    name: "search-widget",
    component: () =>
      import(
        /* webpackChunkName: "search-widget" */ "@/views/search-widget-view.vue"
      ),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "@/views/privacy-view.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () =>
      import(/* webpackChunkName: "terms" */ "@/views/terms-view.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "@/views/contact-view.vue"),
  },
  {
    path: "/iframe-sample",
    name: "iframe-sample",
    component: () =>
      import(
        /* webpackChunkName: "iframe-sample" */ "@/views/iframe-sample-view.vue"
      ),
  },
  {
    path: "/agent-reservation-success",
    name: "agent-reservation-success",
    component: () => import("../views/agent-reservation-success-view.vue"),
  },
  {
    path: "/checkout-iframe",
    name: "checkout-iframe",
    component: () =>
      import(
        /* webpackChunkName: "checkout-iframe" */ "@/views/checkout-iframe-view.vue"
      ),
  },
  {
    path: "/reservation-processed",
    name: "reservation-processed",
    component: () => import("@/views/reservation-processed-view.vue"),
    meta: {
      title: "Reservation Processed",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Navigation guard to handle language changes from URL
router.beforeEach((to, from, next) => {
  // Check for language in query parameters first
  const langParam = to.query.lang as string;

  // Check for language prefix in path
  const pathParts = to.path.split("/");
  const pathLang = pathParts[1];

  let detectedLang: string | null = null;

  // Priority: query param > path prefix
  if (langParam && ["en", "es", "he"].includes(langParam)) {
    detectedLang = langParam;
  } else if (pathLang && ["en", "es", "he"].includes(pathLang)) {
    detectedLang = pathLang;
  }

  // Update i18n locale if language is detected in URL
  if (detectedLang && i18n.locale !== detectedLang) {
    i18n.locale = detectedLang;
  }

  // Always proceed with navigation - no redirects to avoid conflicts
  next();
});

export default router;
